import PlacesAutocomplete, {
    geocodeByAddress,
  } from "react-places-autocomplete";
  import TextField from "@mui/material/TextField";
  import InputAdornment from "@mui/material/InputAdornment";
  import Tooltips from "@mui/material/Tooltip";
  import IconButton from "@mui/material/IconButton";
  import { MdOutlineHome } from "react-icons/md";
  import CircularProgress from "@mui/material/CircularProgress";
  import { useTranslation } from "react-i18next";
  
  export default function PlacesAutoComplete(props) {
    const { t } = useTranslation("products");
    const {
      List,
      HandleAddress,
      HandleAddressSelect,
      Required,
      HandleResidential,
      Color,
    } = props;
  
    return (
      <PlacesAutocomplete
        value={''}
        onChange={''}
        onSelect={''}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <>
            <TextField
              label={t("addNew.address.fullAddress")}
              type="text"
              {...getInputProps({
                placeholder: t("addNew.address.fullAddress"),
              })}
              required={Required}
              sx={{
                width: "100%",
                input: { font: "menu" },
              }}
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {loading && (
                      <CircularProgress size={15} style={{ color: "#C1C1C1" }} />
                    )}
                    {List["type"] === "Tlist" && (
                      <Tooltips title={t("addNew.address.residential")} placement="top">
                        <IconButton
                          edge="end"
                          onClick={HandleResidential}
                          color={Color}
                        >
                          <MdOutlineHome />
                        </IconButton>
                      </Tooltips>
                    )}
                  </InputAdornment>
                ),
              }}
            />
            {suggestions.length !== 0 && (
              <div
                style={{
                  position: "absolute",
                  zIndex: 1021,
                  width: "600px",
                }}
                className="p-1.5 rounded-md border border-ui-border bg-ui-surface shadow-ui-md"
              >
                <div className="mb-1 text-center text-xs font-semibold text-ui-text-muted">
                  {t("addNew.address.suggestions")}
                </div>
                {loading ? (
                  <div className="text-ui-text-muted">{t("addNew.address.loading")}</div>
                ) : null}
                {suggestions.map((suggestion) => {
                  const style = {
                    backgroundColor: suggestion.active
                      ? "var(--color-brand)"
                      : "var(--color-ui-surface)",
                    color: suggestion.active ? "#fff" : "var(--color-ui-text)",
                    whiteSpace: "pre-line",
                  };

                  return (
                    // A div, not <option> — <option> is a native form-control
                    // sub-element and browsers ignore author color/background
                    // on it outside a real <select>, so dark mode never applied.
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        style,
                      })}
                      className="rounded px-2 py-1 text-sm cursor-pointer"
                      key={suggestion.description}
                    >
                      {suggestion.description}
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </PlacesAutocomplete>
    );
  }
  